import { render, staticRenderFns } from "./HospitalityInsurance.vue?vue&type=template&id=74a3aebc"
import script from "./HospitalityInsurance.vue?vue&type=script&lang=js"
export * from "./HospitalityInsurance.vue?vue&type=script&lang=js"
import style0 from "./HospitalityInsurance.vue?vue&type=style&index=0&id=74a3aebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports